export default "__VITE_ASSET__D_wTA8VN__"